import React, { useState } from "react";
import { formatToLocalDateTime } from "../utils/formatDate";
import Loader from "../../../components/Loader";
import { CustomModal } from "./CustomModal";
import { toast, ToastContainer } from "react-toastify";
import { deleteOffer } from "../api/offers";
import del from "../../../assets/del.svg";
import eye from "../../../assets/eye.svg";

interface OfferTableProps {
  tableData: any;
  loading: boolean;
  refetch: boolean;
  setRefetch: React.Dispatch<React.SetStateAction<boolean>>;
}

const OffersTable: React.FC<OfferTableProps> = ({
  tableData,
  loading,
  refetch,
  setRefetch,
}) => {
  const [menuOpen, setMenuOpen] = useState<number | null>(null);
    const [selectedItemId, setSelectedItemId] = useState<number | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = (index: number) => {
    if (index) setMenuOpen(index);
    handleModalActivity();
  };

  const handleModalActivity = () => {
    setIsOpen(!isOpen);
  };

  const handleDeleteOffer = async () => {
    try {
      if (selectedItemId === null) {
        toast.error("No offer selected for deletion");
        return;
      }
      const response = await deleteOffer(selectedItemId);
      if (!response) {
        toast.error("No data received or malformed response");
        console.warn("No data received or malformed response:", response);
        return;
      }
      toast.success("Deleted Successfully");
      handleModalActivity();
      setRefetch(!refetch);
    } catch (error: any) {
      console.error("Failed to fetch employee data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later");
      } else if (error?.response?.status === 500) {
        toast.error("Error while fetching the employee");
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.");
        }
      }
    }
  };
  return (
    <>
      <ToastContainer />
      <CustomModal
        isOpen={isOpen}
        onClose={handleModalActivity}
        onDelete={handleDeleteOffer}
      />
      <div className="h-[calc(100vh-200px)] md:h-[calc(100vh-200px)] overflow-auto page-container p-2 pt-0 scrollbar scrollbar-thin">
        <table className="min-w-full bg-white border border-black-200 table-auto border-separate border-spacing-0">
          <thead className="bg-gray-200 sticky top-[0px] z-20">
            <tr>
              <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
                Title
              </th>
              <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 w-24">
                Description
              </th>
                 <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 w-24">
              Type
              </th>
              <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                File Path
              </th>
              <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
                Created At
              </th>
              <th className="border border-gray-300 text-13 font-bold text-black-500 whitespace-nowrap px-2 py-2 w-1">
                Actions
              </th>
            </tr>
          </thead>
          {loading ? (
            <tbody>
              <tr>
                <td colSpan={16} className="py-8">
                  <div className="flex justify-center items-center w-full">
                    <Loader />
                  </div>
                </td>
              </tr>
            </tbody>
          ) : !loading && tableData?.items?.length === 0 ? (
            <tr>
              <td colSpan={16} className="py-8 text-center text-gray-500">
                No results found
              </td>
            </tr>
          ) : (
            <tbody>
              {Array.isArray(tableData?.items) &&
                tableData.items.map((item: any, index: number) => (
                  <tr key={index} className="border-b text-sm">
                    <td className="border border-gray-300 px-4 py-2">{item.title || "-"}</td>
                    <td className="border border-gray-300 px-4 py-2"> {item.description === "BR" ? "SFA" : (item.description || "-")}</td>
                     <td className="border border-gray-300 px-4 py-2">{item.file_type || "-"}</td>
                    <td className="border border-gray-300 px-4 py-2">
                      {item.file_url ? (
                        <a
                        href={`https://${item.file_url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex justify-center items-center"
                        >
                          <img className="w-4 h-4" src={eye} alt="view" />
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {formatToLocalDateTime(item.created_at) || "-"}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-center relative">
                      <button
                        onClick={() =>
                          
                          {
                            setSelectedItemId(item.id);
                            toggleMenu(item.id)


                          }}
                        className="text-gray-500 hover:text-gray-800"
                      >
                        <img className="w-4" src={del} alt="edit" />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          )}
        </table>
      </div>
    </>
  );
};

export default OffersTable;
